import { NutrientCreate } from '../components/Nutrient/NutrientCreate';
import { NutrientEdit } from '../components/Nutrient/NutrientEdit';
import { NutrientList } from '../components/Nutrient/NutrientList';

export const Nutrients = {
  create: NutrientCreate,
  edit: NutrientEdit,
  list: NutrientList,
};